import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SecureYourFutureWithConfidence from "./sections/SecureYourFutureWithConfidence";
import OurCreativePathways from "./sections/OurCreativePathways";
import TheHeartOfOurMission from "./sections/TheHeartOfOurMission";
import VoicesOfHope from "./sections/VoicesOfHope";
import StoriesInMotion from "./sections/StoriesInMotion";
import PledgeOfSupport from "./sections/PledgeOfSupport";
import FooterIntelligence from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SecureYourFutureWithConfidence />
      <OurCreativePathways />
      <TheHeartOfOurMission />
      <VoicesOfHope />
      <StoriesInMotion />
      <PledgeOfSupport />
      <FooterIntelligence />
    </div>;
}